import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { IndoorControls } from './IndoorControl';
import { addMouseHelper } from './mouseIndicationRing';
import { setEnvironment } from '../js/setEnvironment';
//import { annotation } from './annotation';
import '../style.css';

let camera, renderer;
let group;
var timer, mouseHelper;
let currentSelectedObject;
let selectedRotation;
let canRotate = false;
let floorControls = null;
let isObjectSelected = false;
let touchStartPoint = null
let previousMousePosition = { x: 0, y: 0 };
let scene = new THREE.Scene();
let sprite

// for added object
let group1 = new THREE.Group();
scene.add(group1);

/**
 * Loaders
 */
const gltfLoader = new GLTFLoader();

window.addEventListener('resize', onWindowResize);

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
}

export function loadSceneforDesktop() {
    group = new THREE.Group();
    scene.add(group);

    renderer = new THREE.WebGLRenderer({
        antialias: true
    });
    console.log(renderer)
    renderer.physicallyCorrectLights = true
    renderer.toneMapping = THREE.ReinhardToneMapping
    renderer.toneMappingExposure = 2
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    document.body.appendChild(renderer.domElement);

    camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.set(12, -297, -9);
    camera.lookAt(-5, -294, 0)
    console.log(scene);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 50);
    scene.add(directionalLight);

    setEnvironment(scene, renderer);

    mouseHelper = addMouseHelper(scene);
    //mouseHelper.rotation.set(0,1.57, 0)
    scene.add(mouseHelper);

    loadRoomEnvironment();

    floorControls = new IndoorControls(camera, renderer.domElement);

    floorControls.addEventListener('mousemove', controlCircleProjectionFloor)
    floorControls.addEventListener('touchmove', controlCircleProjectionFloor)

    renderer.domElement.addEventListener('mousedown', onMouseDown, false);



    renderer.domElement.addEventListener('mouseup', onMouseUp, false);

    function onMouseUp(event) {
        event.preventDefault();
        //console.log(scene)
        canRotate = false;
    }

    // to rotate object vertically

    renderer.domElement.addEventListener('mousemove', onMouseMove, false);

    function onMouseMove(event) {
        event.preventDefault();

        if (event.isPrimary === false) return;

        if (isObjectSelected && canRotate) {

            const deltaMove = {
                x: event.offsetX - previousMousePosition.x,
                y: event.offsetY - previousMousePosition.y,
            };

            previousMousePosition = { x: event.offsetX, y: event.offsetY };

        }
    }

    // touch actions

    renderer.domElement.addEventListener('touchstart', onTouchStart, false);

    renderer.domElement.addEventListener('touchend', onTouchEnd, false);

    function onTouchEnd(event) {
        canRotate = false;
        touchStartPoint = null
        if (timer)
            clearTimeout(timer); // clearTimeout, not cleartimeout..
    }

    renderer.domElement.addEventListener('touchmove', onTouchMove, false);

    function onTouchMove(event) {
        event.preventDefault();
        var touch = event.touches[0] || event.changedTouches[0];
        var elm = $(this).offset();
        var x = touch.pageX - elm.left;
        var y = touch.pageY - elm.top;
        if (!touchStartPoint)
            touchStartPoint = { x: x, y: y }


        if (event.isPrimary === false) return;

        if (isObjectSelected && canRotate) {
            currentSelectedObject.rotation.z = -selectedRotation;
        }
    }
}

const progressBar = document.querySelector(".circuler-progress");
const valueContainer = document.querySelector(".value-container");
const loaderContainer = document.querySelector(".loader-container")
const perLoader = document.querySelector(".loader-percentage");
console.log(perLoader)

/**
 * Control: Mouse Move 
 */
function controlCircleProjectionFloor(event) {

    var intersect = event.intersect;
    var normal = intersect.face.normal;
    if (normal.y > 1) {
        mouseHelper.visible = false;
        floorControls.enabled_move = false;

    } else {
        mouseHelper.position.set(0, 0, 0);
        mouseHelper.lookAt(normal);
        mouseHelper.position.copy(new THREE.Vector3(intersect.point.x, intersect.point.y + .1, intersect.point.z));
        mouseHelper.rotation.set(-1.57, 0, 0)
        mouseHelper.position.addScaledVector(normal, 0.001);

        mouseHelper.visible = true;
        floorControls.enabled_move = true;
    }
}

/**
 * Room
 */
function loadRoomEnvironment() {
    var textureLoader = new THREE.TextureLoader();
    gltfLoader.load(
        '/models/Booth_v3.glb',
        (gltf) => {
            gltf.scene.traverse(function (child) {
                if (child instanceof THREE.Mesh) {
                    child.geometry.computeVertexNormals();
                    if (child.name == 'mesh_14') {// ||  child.name == 'mesh_1'){
                        floorControls.ground.push(child);
                    }
                    // if (child.name == 'mesh_10' || child.name == 'mesh_14' || child.name == 'mesh_12' || child.name == 'mesh_18' || child.name == 'mesh_20' || child.name == 'mesh_16') {
                    //     child.material.emissive = new THREE.Color(0xffffff);
                    //     child.material.emissiveIntensity = 1
                    // }
                }
            })
            gltf.scene.castShadow = true;
            gltf.scene.receiveShadow = true;
            gltf.scene.scale.set(2, 2, 2);
            gltf.scene.position.set(0, -300, 0);
            group.add(gltf.scene)
            //loadDefaultModels();
            animate();
        },
        function (xhr) {
            let percentage = (xhr.loaded / 20932538 * 100)
            valueContainer.textContent = `${percentage.toFixed(1)}%`
            progressBar.style.background = `conic-gradient(
                #59b2dc ${percentage * 3.6}deg,
                #000000 ${percentage * 3.6}deg
                )`;
            // if (percentage < 100)
            //     perLoader.innerHTML = `<h2>${percentage.toFixed(2)} % loaded</h2>`;

            console.log(xhr)
            if (percentage == 100) {
                valueContainer.textContent = `Loading.....`
                setTimeout(myGreeting, 5000);
            }
        }
    )
}

function myGreeting() {
    loaderContainer.style.display = 'none';
}

/**
 * Mouse Down Event
 */

function onMouseDown(event) {
    event.preventDefault();
}

/**
 * Touch Start Event
 */

function onTouchStart(event) {
}

/**
 * Animate
 */
function animate() {
    requestAnimationFrame(animate);
    floorControls.update();
    render();
    //composer.render()
}

function render() {
    renderer.render(scene, camera);
}
